module.exports = new __parcel__URL__("leavingstone.e3e74946.png").toString();